// @ts-nocheck
import React, { useState, useEffect } from 'react'
import { usePermissions } from '../../../context/PermissionsContext';
import { useParams } from "react-router";
import ExerciseAdminPage from '../../../components/ExerciseAdminPage'
import useTargetingPermissions from '../hooks/useTargetingPermissions'
//import HcpUserTitles from './components/HCP/UserTitles'
import HcpResult from './components/HCP/Result'
import HcoUserTitles from './components/HCO/UserTitles'
import HcoResult from './components/HCO/Result'
import Approve from './components/Approve'
import apiFetch from '../../../api/apiFetch'
import styles from './css/Result.module.css';
import { TYPE_ORDER } from '../targetingUtils'
import targetingDefaultPerTargetLimits from '../../../lookup/admin/targeting/targetingDefaultPerTargetLimits.json'

function Admin(props) {

    const permissions = usePermissions();
    const { isAdminUser, isMultiExerciseAdmin } = useTargetingPermissions()
    const currentExercise = props.exercise

    const [data, setData] = useState([])
    const [loaded, setLoaded] = useState(false)
    const {idSlug} = useParams()

    useEffect(() => {
        if (isAdminUser) {
            apiFetch('/api/v2/targeting/approval-check', { ID: currentExercise.ID }).then((data) => {
                props.setApproved(data.length > 0)
            })
        }
    }, [])

    const getData = () => {

        let terr_id_temp = isMultiExerciseAdmin && currentExercise != undefined ? props.user.terr : isAdminUser && currentExercise != undefined ? currentExercise.TEAM : props.user.terr;

        //leaving this in jank mode with magic roles at least for now (call out for PR)
        if ((props.user.role !== "ADMIN" && (props.user.terr === 'undefined' || props.user.terr === '')) || (props.user.role === 'ODB' || props.user.role ==='DBD' || props.user.role ==='IDD')) {
            if (currentExercise != undefined && currentExercise.TEAM != terr_id_temp.substr(0, 2)) {

                terr_id_temp = currentExercise.TEAM + terr_id_temp.substr(2, terr_id_temp.length - 2);

            }
        }

        let requestData = {
            terr: terr_id_temp,
            id: isAdminUser && currentExercise != undefined ? currentExercise.TARGETING_EXERCISE_ID : props.exercise.TARGETING_EXERCISE_ID,
            role: props.user.role,
            type: isAdminUser && currentExercise != undefined ? currentExercise.CUSTOMER_TYPE : props.exercise.CUSTOMER_TYPE,
            team: isAdminUser && currentExercise != undefined ? currentExercise.TEAM : props.exercise.TEAM,
            user: props.user.userName
        }

        apiFetch('/api/v2/targeting/get-current-totals', requestData).then((rows) => {
            if (!Array.isArray(rows)) {
                setLoaded(true)
                return
            }
            const byTerr = {}
            rows.forEach(row => {
                const k = row.TERR_ID
                if (k == null) return
                if (!byTerr[k]) {
                    byTerr[k] = {
                        TERR_ID: row.TERR_ID,
                        TERR_NAME: row.TERR_NAME ?? '',
                        FIRST_NAME: row.FIRST_NAME ?? '',
                        LAST_NAME: row.LAST_NAME ?? '',
                        STATUS_ID: row.STATUS_ID,
                        STATUS: row.STATUS ?? '',
                    }
                }
                if (row.TARGET_TYPE) {
                    byTerr[k][`FINAL_TOTAL_${row.TARGET_TYPE}`] = row.FINAL_TOTAL ?? 0
                    byTerr[k][`CURRENT_TOTAL_${row.TARGET_TYPE}`] = row.CURRENT_TOTAL ?? 0
                }
            })
            setData(
                Object.values(byTerr).sort((a, b) => {
                    const statusDiff = (b.STATUS_ID ?? 0) - (a.STATUS_ID ?? 0)
                    if (statusDiff !== 0) return statusDiff
                    return (a.TERR_ID ?? '').localeCompare(b.TERR_ID ?? '')
                })
            )
            setLoaded(true)
        })
    }
    const endpoints = {
        status: '/api/v2/targeting/get-statuses',
        editStatus: '/api/v2/targeting/edit-status'
    }

    const perTargetLimits = currentExercise?.PER_TARGET_LIMITS
        ? JSON.parse(currentExercise.PER_TARGET_LIMITS)
        : targetingDefaultPerTargetLimits.team[currentExercise?.TEAM]?.defaultTargetOptions ?? null;
    const activeTargets = perTargetLimits
        ? TYPE_ORDER.filter(t => perTargetLimits[t]?.allowChanges)
        : ['A', 'B', 'C'];

    let hcpUserTitles = () => {
        return (
            <div className={styles.titles}>
                <div className={[styles.col, styles.long].join(' ')}>TERRITORY</div>
                <div className={[styles.col, styles.short, styles.center].join(' ')}>Rep Name</div>
                {activeTargets.map(t => (
                    <div key={t} className={[styles.col, styles.short, styles.center].join(' ')}>{t}</div>
                ))}
                <div className={[styles.col, styles.select, styles.center].join(' ')}>STATUS</div>
                <div className={[styles.col, styles.long, styles.center].join(' ')}>ACTIONS</div>
            </div>
        );
    }

    return (
        <ExerciseAdminPage
            {...props}
            headerTitle={'Targeting Exercises'}
            getData={getData}
            data={data}
            setData={setData}
            loaded={loaded}
            setLoaded={setLoaded}
            endpoints={endpoints}
            titles={hcpUserTitles}
            result={HcpResult}
            approve={Approve}
        />
    )
}

export default Admin
